import {default as ExcelFile, ExcelSheet ,ExcelColumn} from "react-data-export" 
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import firebase from 'firebase';
import store from '../../store';
import {Link} from 'react-router-dom';



const database=firebase.database();


const styles={marginTop:'40px'}

class ReporteCalificaciones extends Component{
	
	
		
    	constructor(props){
		
			super(props);
			this.state={
				labels:['Cliente','Empleado','Fecha','Pago','Total','Pregunta','Puntaje'],
				viajes:[],
				calificaciones:[],
				clientes:[],
				empleados:[],
				fecha_actual:'',
				input_disabled:'disabled',
				fecha_minima:'',
				viajes_temp:''
				

			}
			
		
			this.CalificacionesRef=database.ref().child('Calificaciones');
			this.calificacionRef=database.ref().child('Viaje');	
			this.ClientesRef=database.ref().child('Clientes');
			this.EmpleadosRef=database.ref().child('Empleados');
			
			this.handleInputDate1Change=this.handleInputDate1Change.bind(this);
			this.handleInputDate2Change=this.handleInputDate2Change.bind(this);
			this.handleKeyPress=this.handleKeyPress.bind(this);
			this.handleClickPrint=this.handleClickPrint.bind(this);
			this.updateStateReport=this.updateStateReport.bind(this);
			
				let f=new Date();
		
				this.state.fecha_actual=f.getFullYear()+'-'+((f.getMonth()+1)>10 ? f.getMonth:'0'+(f.getMonth()+1))+'-'+(f.getDate()>10?f.getDate():'0'+f.getDate());

				
				
		}
		
		
		
		componentDidMount(){
						
			this.EmpleadosRef.once('value',this.gotDataEmpleados,this.errDataEmpleados);
			
		}
		componentWillMount(){
			
			this.EmpleadosRef.once('value',this.gotDataEmpleados,this.errDataEmpleados);
			
		}
		
		
		
		gotDataEmpleados=(data)=>{
			
			
			let newEmpleados=[];
			
			if(data.val()!==null){
				
				
				let dataEmpleados=data.val();
				let keys=Object.keys(dataEmpleados);
				
				for(let i=0;i<keys.length;i++){
					
					
					let k=keys[i];
					
					newEmpleados.push({
						key:k,
						nombre:dataEmpleados[k].nombre
						
					})				
				}
				this.setState({empleados:newEmpleados})				
			}			
			
			this.ClientesRef.once('value',this.gotDataClientes,this.errDataClientes);
			
		}
		errDataEmpleados=(err)=>{
			
			
			console.log(err);
			
		}
		
		
		gotDataClientes=(data)=>{
			
			let newClientes=[];
			
			
			if(data.val()!==null){
				
				
				let dataClientes=data.val();
				let keys=Object.keys(dataClientes);
				
				for(let y=0;y<keys.length;y++){
					
					let k=keys[y];
					
					newClientes.push({
						key:k,
						nombre:dataClientes[k].nombre,
						apellido:dataClientes[k].apellido
						
					})					
				}
				this.setState({					
					clientes:newClientes
				})				
			}
			this.CalificacionesRef.once('value',this.gotDataCalificaciones,this.errDataCalificaciones);
		}
		errDataClientes=(err)=>{
			
			console.log(err);
			
		}
		
		
		gotDataCalificaciones=(data)=>{
			
			let newCalificaciones=[]
			
			if(data.val()!==null){
				
				let dataCalificaciones=data.val();
				let keys=Object.keys(dataCalificaciones);
				
				for(let i=0;i<keys.length;i++){
					
					let k=keys[i];
						
			
					newCalificaciones.push({
						key:k,
						estado:dataCalificaciones[k].estado,
						pregunta:dataCalificaciones[k].pregunta,
						tipo:dataCalificaciones[k].tipo						
					})
				}
				
				this.setState({					
					calificaciones:newCalificaciones
					
				})
			}
			
			this.calificacionRef.once('value',this.gotDataCalificacion,this.errDataCalificacion);
			
		}
		errDataCalificaciones=(err)=>{
			
			console.log(err);
			
		}
		
		
		gotDataCalificacion=(data)=>{
			
			
			let newCalificacion=[];
			
			if(data.val()!==null){
				
				
				let dataViajes=data.val();
				let keys=Object.keys(dataViajes);
				
				
				for(let i=0;i<keys.length;i++){
					
					let k=keys[i];
					
					if(dataViajes[k].Calificacion!==undefined){
													
						let values=Object.values(dataViajes[k].Calificacion);
						let keyss=Object.keys(dataViajes[k].Calificacion);
						
										
						for(let j=0;j<keyss.length;j++){
							
							let kk=keyss[j];
							
							
							
							let pregunta=this.state.calificaciones.find(c=> c.key===kk);
							let cliente=this.state.clientes.find(c=> c.key==dataViajes[k].cliente);
							let empleado=this.state.empleados.find(e=> e.key===dataViajes[k].empleado);
							
							
							if(pregunta!==undefined && cliente!==undefined && empleado!==undefined){
								
								try{
									newCalificacion.push({
										cliente:cliente.nombre+' '+cliente.apellido,
										empleado:empleado.nombre,
										direccion:dataViajes[k].direccion,
										fecha:dataViajes[k].fechaBajada.substring(0,10),
										lugar:dataViajes[k].lugar,
										pago:dataViajes[k].pago,
										total:'$'+dataViajes[k].total,
										pregunta:pregunta.pregunta,
										puntaje:values[j].calificacion,
										distancia:dataViajes[k].distancia
										
										})
								}
								catch(error){
									console.log(error)
								}
								
							}

							
						}
										
					}
									
				}
				this.setState({viajes:newCalificacion, viajes_temp:newCalificacion})
				
				
			}
			
		}
		errDataCalificacion=(err)=>{
			
				console.log(err);
		}
		
		
		handleInputDate1Change=()=>{
			
			
			let fecha1=this.fecha1.value;
			this.fecha2.value=""
			
			this.setState({
				
				input_disabled:'',
				fecha_minima:fecha1
				
			})

		}
		
		//Aqui se realiza el filtro por fechas
		handleInputDate2Change=()=>{
		
			this.state.viajes=this.state.viajes_temp;
						
			let fecha1=this.fecha1.value;
			let fecha2=this.fecha2.value;
			
			let temp=[]
			
			let f1=new Date(fecha1);
			let f2=new Date(fecha2);
			
		
			
			for(let i=0;i<this.state.viajes.length;i++){
				
				let fecha_actual=(new Date(this.state.viajes[i].fecha)).getTime();
				
				if(fecha_actual>=f1.getTime() && fecha_actual<=f2.getTime() ){
					
					temp.push({
								key:this.state.viajes[i].key,
								cliente:this.state.viajes[i].cliente,
								empleado:this.state.viajes[i].empleado,
								direccion:this.state.viajes[i].direccion,
								fecha:this.state.viajes[i].fecha,
								lugar:this.state.viajes[i].lugar,
								pago:this.state.viajes[i].pago,
								total:this.state.viajes[i].total,
								pregunta:this.state.viajes[i].pregunta,
								puntaje:this.state.viajes[i].puntaje,
								distancia:this.state.viajes[i].distancia
						
					})
					
				}
				
			}
			this.state.viajes=temp;
			this.setState({
				fecha2:fecha2				
			})
			
		}
		
		//Filtros para la caja de texto
		handleKeyPress=()=>{
			
						
			let fecha1=this.fecha1.value;
			let fecha2=this.fecha2.value;
			
			let f1=new Date(fecha1);
			let f2=new Date(fecha2);
			
			
			
			this.state.viajes=this.state.viajes_temp;
			
			let temp=[];
			
			
			for(let i=0;i<this.state.viajes.length;i++){
				
					let fecha_actual=(new Date(this.state.viajes[i].fecha)).getTime();
				
					let cliente=false;
					let empleado=false;
					let fecha=false;
					let pago=false;
					let total=false;
					let pregunta=false;
					let puntaje=false;
					let lugar=false;
					
					
					if(this.state.viajes[i].cliente!==undefined)
					cliente=(this.state.viajes[i].cliente.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
				
					if(this.state.viajes[i].empleado!==undefined)
					empleado=(this.state.viajes[i].empleado.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
				
					if(this.state.viajes[i].fecha!==undefined)
					fecha=(this.state.viajes[i].fecha.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
				
					if(this.state.viajes[i].pago!==undefined)
					pago=(this.state.viajes[i].pago.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
					
					if(this.state.viajes[i].total!==undefined)
					total=(this.state.viajes[i].total.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
					
					if(this.state.viajes[i].pregunta!==undefined)
					pregunta=(this.state.viajes[i].pregunta.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
			
					if(this.state.viajes[i].puntaje!==undefined)
					puntaje=(this.state.viajes[i].puntaje===this.busqueda.value? true : false);
				
				
					if(this.state.viajes[i].lugar!==undefined)
					lugar=(this.state.viajes[i].lugar.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false);
				
				
					
					
					if(this.fecha1!=="" && this.fecha2.value!==""){
					
					
				
					
						if((fecha_actual>=f1.getTime() && fecha_actual<=f2.getTime()) && (cliente || empleado || fecha || pago || total || pregunta || puntaje || puntaje || lugar)){
							
							
							
							temp.push({
								key:this.state.viajes.key,
								cliente:this.state.viajes[i].cliente,
								empleado:this.state.viajes[i].empleado,
								fecha:this.state.viajes[i].fecha,
								pago:this.state.viajes[i].pago,
								total:this.state.viajes[i].total,
								pregunta:this.state.viajes[i].pregunta,
								puntaje:this.state.viajes[i].puntaje,
								lugar:this.state.viajes[i].lugar,
								distancia:this.state.viajes[i].distancia						
							})							
						}
					}				
					else{
						
						
						
						if(cliente || empleado || fecha || pago || total || pregunta || puntaje || lugar){						
							temp.push({
								key:this.state.viajes.key,
								cliente:this.state.viajes[i].cliente,
								empleado:this.state.viajes[i].empleado,
								fecha:this.state.viajes[i].fecha,
								pago:this.state.viajes[i].pago,
								total:this.state.viajes[i].total,
								pregunta:this.state.viajes[i].pregunta,
								puntaje:this.state.viajes[i].puntaje,
								lugar:this.state.viajes[i].lugar,
								distancia:this.state.viajes[i].distancia						
							})
						}
					}
				
			}
			this.state.viajes=temp;
			this.setState({
				viajes:temp
			})
			
			
		}
		
		handleClickPrint=()=>{
			
			this.updateStateReport();
			
		}
		
		updateStateReport(){
		
			store.dispatch({
				
				type: "STATE_REPORT",
				labels_report:this.state.labels,
				data_report:this.state.viajes,
				tipo_reporte:'reporte_calificaciones'
				
			})
		
		}
		
		
	render(){
		
		return(
		
			<div className="container">
		
				<center><h3>Reporte de calificaciones por viaje</h3></center>
			
				
			
			
			
				<div className="row margen-divs-filtros" style={styles} >
					<div className="col-md-4 col-sm-3 col-xs-3">
						<ExcelFile  filename="Reporte_Viajes.xlsx" element={(<button className="btn btn-success btn-sm excel"><span className="glyphicon glyphicon-download-alt"></span> Descargar Excel </button>)}>				
									<ExcelSheet data={this.state.viajes} name="Viajes">
											<ExcelColumn label="Cliente" value="cliente" />										
											<ExcelColumn label="Conductor" value="empleado" />										
											<ExcelColumn label="Dirección" value="direccion" />										
											<ExcelColumn label="Distancia en km" value="distancia" />										
											<ExcelColumn label="Fecha Bajada" value="fecha" />										
											<ExcelColumn label="Pago" value="pago" />										
											<ExcelColumn label="Destino" value="lugar" />																				
											<ExcelColumn label="Total" value="total" />																				
											<ExcelColumn label="Pregunta" value="pregunta"/>
											<ExcelColumn label="Puntaje" value="puntaje"/>
						            </ExcelSheet>						
						</ExcelFile>
					</div>
					<div className="col-md-1 col-xs-2">
					</div>
					<div className="col-md-4 col-sm-4 col-xs-4">
						<Link to="template" className="btn btn-success" onClick={this.handleClickPrint}><span className="glyphicon glyphicon-print"> Imprimir</span></Link>
					</div>
	
				</div>
			
			
				<div className="row margen-divs-filtros">
					<div className="col-md-4 col-sm-4 col-xs-12">
						<label for="fechaInicio">Fecha Inicio</label>
						<input type="date" className="form-control" id="fechaInicio" max={this.state.fecha_actual} onChange={this.handleInputDate1Change}
							   ref={input=>{this.fecha1=input;}}
						/>
					</div>
					<div className="col-md-4 col-sm-4 col-xs-12" >
						<label for=" fechaFinal">Fecha Final</label>
						<input type="date" className="form-control" id="fechaFinal" disabled={this.state.input_disabled} ref={input=>{this.fecha2=input;}}
							min={this.state.fecha_minima} max={this.state.fecha_actual} onChange={this.handleInputDate2Change}
						/>						
					</div>
				
				</div>

				
				<div className="row input-filter">
							<div className="col-md-4">
							</div>
							<div className="col-md-4">
							</div>
							<div className="col-md-4 ">
								<input type="text" className="form-control" onKeyUp={this.handleKeyPress}
									ref={input => {this.busqueda=input;}} 
									placeholder="Buscar"
								/>
							</div>
				</div>
				
			
				<BootstrapTable data={ this.state.viajes }
				 ref='table'			 
				 pagination={ true }
				 search={ false }
				 hover
				 >
				 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
				 <TableHeaderColumn dataField='cliente' dataSort={true}>Cliente</TableHeaderColumn>
				 <TableHeaderColumn dataField='empleado' dataSort={true}>Conductor</TableHeaderColumn>
				 <TableHeaderColumn dataField='fecha' dataAlign="center">Fecha</TableHeaderColumn>
				 <TableHeaderColumn dataField='pago' dataAlign="center">Pago</TableHeaderColumn>
				 <TableHeaderColumn dataField='total' dataAlign="center">Total</TableHeaderColumn>
				 <TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='pregunta' >Pregunta</TableHeaderColumn>
				 <TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='lugar'>Lugar</TableHeaderColumn>
				 <TableHeaderColumn dataField='puntaje' dataAlign="center">Puntaje</TableHeaderColumn>
				 
				 
			  </BootstrapTable>
				

			</div>
		
		
		);
		
		
		
	}
}
	
	
	
	
	



export default ReporteCalificaciones;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteCalificaciones.js